import { render, staticRenderFns } from "./tips-accordion.vue?vue&type=template&id=010e5f48&"
import script from "./tips-accordion.vue?vue&type=script&lang=js&"
export * from "./tips-accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports